module.exports = __webpack_public_path__ + "ded23d29a8289b25d3f5f0435f8321cf.png";